
window.addEventListener('DOMContentLoaded', function() {
    const emailInput = document.querySelector('.popup-link__inner .email-signup__input');
    const submitButton = document.querySelector('.popup-link__inner .email-signup__button ');

    emailInput.addEventListener('input', function() {
        submitButton.disabled = emailInput.value.trim() === '';
    });


    const dialogEl = document.querySelector('.footer-signup-section .group-block-content .popup-link');
    if (!dialogEl) return;

    // show only once per tab/session (first page the user lands on)
    if (sessionStorage.getItem('welcome_popup_shown') === '1') return;
    // sessionStorage.setItem('welcome_dialog_shown', '1');

    // await customElements.whenDefined('dialog-component');
    dialogEl.showDialog(); // from Horizon's dialog.js

    dialogEl.addEventListener('dialog:close', function(){
      sessionStorage.setItem('welcome_popup_shown', '1');
    }, { once: true });


});



// Add this script before the closing </body> tag or in your theme.js
document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.footer-signup-section .email-signup__form');
  const messageContainer = document.querySelector('#signup-message');

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault(); // Stop page reload

      const formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(response => {
        if (response.ok) {
          messageContainer.innerText = 'Thanks for subscribing!';
          form.reset(); // Optional: Clear form
        } else {
          messageContainer.innerText = 'Error. Please try again.';
        }
      })
      .catch(error => {
        messageContainer.innerText = 'An error occurred.';
      });
    });
  }
});






